import { useEffect } from "react";
import useNativePush from "../hooks/useNativePush";

/**
 * Runs Capacitor-only setup (status bar style, hardware back button,
 * native push registration) exactly once on app mount. On browsers (PWA)
 * everything inside is a no-op since window.Capacitor is undefined.
 */
export default function NativeBootstrap() {
  useNativePush();

  useEffect(() => {
    const isNative = typeof window !== "undefined" && window.Capacitor?.isNativePlatform?.();
    if (!isNative) return;

    let cleanup = () => {};
    (async () => {
      try {
        const { StatusBar, Style } = await import("@capacitor/status-bar");
        await StatusBar.setStyle({ style: Style.Dark });
        await StatusBar.setBackgroundColor({ color: "#0D1117" });
        await StatusBar.setOverlaysWebView({ overlay: false });
      } catch (e) {
        console.warn("Capacitor StatusBar setup failed:", e);
      }
      try {
        const { App } = await import("@capacitor/app");
        const handler = await App.addListener("backButton", ({ canGoBack }) => {
          if (canGoBack) {
            window.history.back();
          } else {
            App.exitApp();
          }
        });
        cleanup = () => handler.remove();
      } catch (e) {
        console.warn("Capacitor App back-button handler failed:", e);
      }
    })();

    return () => cleanup();
  }, []);

  return null;
}
